module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.supportAndroid) ? _c('div', {
    ref: "wxc-pan-item",
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-horizontalpan": "",
      "weex-appear": "",
      "data-evt-appear": "",
      "data-evt-disappear": "",
      "data-evt-click": ""
    },
    on: {
      "horizontalpan": _vm.dispatchPan,
      "appear": function($event) {
        $event.stopPropagation();
        return _vm.onItemAppear($event)
      },
      "disappear": function($event) {
        $event.stopPropagation();
        return _vm.onItemDisAppear($event)
      },
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.itemClicked($event)
      }
    }
  }, [_vm._t("default", null, {})], 2) : _c('div', {
    ref: "wxc-pan-item",
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.itemClicked($event)
      }
    }
  }, [_vm._t("default", null, {})], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e43049a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e43049a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-pan-item/index.vue
// module id = 209
// module chunks = 0 1